import * as React from 'react';

interface IProps<T> {
    data: Array<T>;
    RowCellsComponent: React.StatelessComponent<{item: T}>;
    HeaderCellsComponent?: React.ComponentType<{}>;
    style?: React.CSSProperties;
    rowStyle?: React.CSSProperties;
}

interface IIdentified {
    id: string;
}

export class Table<T extends IIdentified> extends React.Component<IProps<T>> {
    public render() {
        const { data, RowCellsComponent, HeaderCellsComponent } = this.props;

        const RowLambda = ({children, style= ( {} as React.CSSProperties )}: any) => {
            return <div style={{...styles.defaultRow, ...this.props.rowStyle, ...style}}>
                {children}
            </div>;
        };

        let headerRow = null as JSX.Element | null;
        if (HeaderCellsComponent) {
            headerRow = <RowLambda style={{justifyContent: 'flex-end'}}>
                <HeaderCellsComponent/>
            </RowLambda>;
        }

        const dataRows = data.map(item => {
            return <RowLambda key={item.id}>
                <RowCellsComponent item={item}/>
            </RowLambda>;
        });

        return <div style={{ ...styles.table, ...this.props.style }}>
            {headerRow}
            {dataRows}
        </div>;
    }
}

const styles = {
    table: { flexDirection: 'column', display: 'flex' } as React.CSSProperties,
    defaultRow: { display: 'flex', alignItems: 'flex-start' } as React.CSSProperties
};



// WEBPACK FOOTER //
// ./src/Pages/NotificationsPage/Table.tsx